import { Bundle, BundlePurchasePayload } from "../../../../types";

export function buildBundleCheckoutPayload(
  bundle: Bundle,
  isGold: boolean,
): BundlePurchasePayload {
  const salePricePoint = isGold
    ? bundle.ppb_gold_sale_price_point
    : bundle.ppb_sale_price_point;
  const regularPricePoint = isGold
    ? bundle.ppb_gold_price_point
    : bundle.ppb_price_point;
  const pricePoint = salePricePoint || regularPricePoint;
  const price = isGold ? bundle.gold_price : bundle.price;

  // Calculate full price from all items
  const fullPrice = bundle.items.reduce((total, item) => {
    return total + item.ppb_price_point / 100; // Convert cents to dollars
  }, 0);

  const payload: BundlePurchasePayload = {
    price_point_id: pricePoint,
    currency_code: "USD",
    raw_price: price.price_float_discounted ?? price.price_float,
    full_price: fullPrice,
    is_gold: isGold,
    is_sale: !!salePricePoint,
  };

  // Add dynamic raw_price_* fields for each item's price point
  bundle.items.forEach((item) => {
    const key = `raw_price_${item.ppb_price_point}`;
    (payload as any)[key] = item.ppb_price_point / 100;
  });

  return payload;
}
